// src/stores/authStore.js
import { create } from 'zustand';

const useAuthStore = create((set, get) => ({
  // ===== 状態 =====
  accessToken: sessionStorage.getItem('accessToken') || '',
  refreshToken: sessionStorage.getItem('refreshToken') || '',
  userName: sessionStorage.getItem('WuserName') || '',
  userType: sessionStorage.getItem('WuserType') || '',

  // ===== 計算プロパティ =====
  isAuthenticated: () => !!get().accessToken,
  isAdmin: () => get().userType === 'admin',
  isOperator: () => get().userType === 'operator',
  isEnduser: () => get().userType === 'enduser',
  isSystem: () => get().userType === 'system',

  // ===== アクション =====
  login: ({ access, refresh, WuserName, WuserType }) => {
    if (access) sessionStorage.setItem('accessToken', access);
    if (refresh) sessionStorage.setItem('refreshToken', refresh);
    if (WuserName) sessionStorage.setItem('WuserName', WuserName);
    if (WuserType) sessionStorage.setItem('WuserType', WuserType);

    set({
      accessToken: access || '',
      refreshToken: refresh || '',
      userName: WuserName || '',
      userType: WuserType || '',
    });
  },

  logout: () => {
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('WuserName');
    sessionStorage.removeItem('WuserType');

    set({
      accessToken: '',
      refreshToken: '',
      userName: '',
      userType: '',
    });
  },

  // ===== プロフィール更新用アクション（追加） =====
  updateProfile: ({ userName }) => {
    if (userName !== undefined) {
      sessionStorage.setItem('WuserName', userName);
    }
    set((state) => ({
      ...state,
      ...(userName !== undefined && { userName }),
    }));
  },

  setAccessToken: (token) => {
    sessionStorage.setItem('accessToken', token);
    set({ accessToken: token });
  },
}));

export default useAuthStore;